import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AddressModel, CityStateModel, CustomerOrderDetail, CustomerOrderDetails, CustomerVM, OrderListVM } from '../models/customer/customer.model';
import { ConfirmAccountModel } from '../models/login/login.model';
import { ApiService } from './Common/api.service';
import { UrlHelperService } from './Common/urlhelper.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  constructor(private _api: ApiService) { }
  CustomerAddressAdd(customerVm: CustomerVM) {
    return this._api.post(UrlHelperService.customerAddAddress, customerVm)
  }
  GetCustomerAddressList(){
    return this._api.post(UrlHelperService.customerAddressList)
  }
  getAddressId = new BehaviorSubject(<string>'');
  passId(id) {
    this.getAddressId.next(id);
  }
  getUserId = new BehaviorSubject(<string>'');
  passUserId(userId) {
    this.getAddressId.next(userId);
  }
  DeleteAddressList(CustomerAddressVm: CustomerVM){
    return this._api.post(UrlHelperService.deleteCustomerList, CustomerAddressVm)
  }
  CustomerUpdateAddress(addressUpdateVm: CustomerVM) {
    return this._api.post(UrlHelperService. upadteCustomerAddressDetail, addressUpdateVm)
  }
  GetAddressPostalNumber(GeoPostalCode) {
    return this._api.get(UrlHelperService. getCityStatePostalCode + GeoPostalCode)
  }
  GetCustomerAddressById(id) {
    return this._api.get(UrlHelperService. getCustomerById + id)
  }
  CustomerAddressList() {
    return this._api.post(UrlHelperService.confirmCustomerAddressList)
  }
  GetCustomerOrderList(orderCustomerVm: OrderListVM){
    return this._api.post(UrlHelperService.customerOrderList, orderCustomerVm)
  }
  GetCustomerOrderDetail(id){
    return this._api.post(UrlHelperService.customerOrderDetail + id)
  }
  GetUserVerification(token: ConfirmAccountModel){
    return this._api.post(UrlHelperService.UserVerification, token)
  }

  GetCustomerinvoiceDetail(id){
    return this._api.post(UrlHelperService.CustomerinvoiceDetail + id)
  }
 
}
